import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IsentropicService } from '../../isentropic.service';
import { Senf } from '../senf';


@Component({
    selector: 'app-if-ttt',
    templateUrl: './if-ttt.component.html',
    styleUrl: './if-ttt.component.scss',
    standalone: false
})
export class IfTttComponent implements OnInit {
  tmprForm: FormGroup | undefined;
  tBool?: boolean;
  tSenf: Senf | undefined;

  constructor(private fBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.tmprForm = this.fBuilder.group({
        tmprVal: ['', [
        Validators.required,
        Validators.max(.99999)
        ]],
        gammaVal: ['', [
        Validators.required,
        Validators.min(1.000001),
        Validators.max(1.67)
        ]]
     })
   }

   mach_from_tmpr(tmpr:string, gamma:string): number {
    let machNr:number = Math.sqrt(2 *((1/Number(tmpr))-1)/(Number(gamma)-1));
    return Number(machNr.toFixed(2));
  }

  onSubmit(): void {
    this.tBool = true;
    this.tSenf = new Senf();
    this.tSenf!._tempRat = this.tmprForm?.get('tmprVal')!.value;
    this.tSenf!.gammaVal = this.tmprForm?.get('gammaVal')!.value;
    this.tSenf!.machVal = this.mach_from_tmpr(this.tmprForm?.get('tmprVal')?.value, this.tmprForm?.get('gammaVal')!.value);
    this.tSenf?.senfCalc(Number(this.tmprForm?.get('gammaVal')?.value), this.tSenf!.machVal);

  }

  isenMach() {
    return this.tSenf?.machVal;
  }

  isenp_pt() {
      return this.tSenf?.pressureRat;
  }

  isenT_Tt() {
      return this.tSenf?.tempRat;
  }

  isenpA_ptAstar() {
      return this.tSenf?.paptas;
  }

  isenpm() {
      return this.tSenf?.pmr;
  }

  isenmach_angle() {
      return this.tSenf?.machAng;
  }


  isen_cfopt() {
      return this.tSenf?.cfOpt;
  }

  isen_rhot() {
      return this.tSenf?.rhorhot;
  }

  isenA_As() {
      return this.tSenf?._areaRat;
  }

}
